import { Autocomplete, TextField } from '@mui/material';
import { find, some } from 'es-toolkit/compat';
import React from 'react';

import { ManifestCaseTarget } from './dialogState';

export interface ManifestTargetCaseOption {
  id: number | 'new';
  label: string;
}

interface CaseManifestTargetCaseCellProps {
  disabled: boolean;
  loading: boolean;
  onChange: (target: ManifestCaseTarget) => void;
  options: ManifestTargetCaseOption[];
  slideLabel: string;
  target: ManifestCaseTarget;
}

export const CaseManifestTargetCaseCell = ({
  disabled,
  loading,
  onChange,
  options,
  slideLabel,
  target,
}: CaseManifestTargetCaseCellProps) => {
  const selectedOption =
    find(options, (option) => option.id === target) ||
    (typeof target === 'number'
      ? { id: target, label: `${loading ? 'Loading case' : 'Unavailable case'} (${target})` }
      : null);

  return (
    <Autocomplete<ManifestTargetCaseOption>
      fullWidth
      size="small"
      options={selectedOption && !some(options, { id: selectedOption.id }) ? [...options, selectedOption] : options}
      value={selectedOption}
      disabled={disabled}
      loading={loading}
      getOptionDisabled={(option) => !some(options, { id: option.id })}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={(option) => option.label}
      // Keyed by id: the default key is the label, which repeats when saved labels collide.
      renderOption={(props, option) => (
        <li {...props} key={option.id}>
          {option.label}
        </li>
      )}
      noOptionsText="No matching cases"
      onKeyDown={(event) => event.stopPropagation()}
      onChange={(_event, value) => onChange(value?.id ?? null)}
      renderInput={(params) => (
        <TextField
          {...params}
          required
          placeholder="Select a case"
          inputProps={{ ...params.inputProps, 'aria-label': `Target case for ${slideLabel}` }}
        />
      )}
    />
  );
};
